import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    omrConfigs: [],
    pageIndex: 1,
    size: 10,
    search: undefined,
    totalCount: 0
};

const omrConfig = createSlice({
    name: 'omrConfig',
    initialState,
    reducers: {
        setOMRConfigs(state, action) {
            state.omrConfigs = action.payload;
        },
        setOMRConfigTotalCount(state, action) {
            state.totalCount = action.payload;
        },
        addOMRConfig(state: any, action) {
            state.omrConfigs = [action.payload, ...state.omrConfigs];
            state.totalCount += 1;
        },
        updateOMRConfigInList(state: any, action) {
            const index = state.omrConfigs.findIndex((config: any) => config._id === action.payload._id);
            if (index !== -1) {
                state.omrConfigs[index] = action.payload;
            }
        },
        deleteOMRConfig(state: any, action) {
            state.omrConfigs = state.omrConfigs.filter((config: any) => config._id !== action.payload);
            state.totalCount -= 1;
        },
        setOMRConfigPageIndex(state, action) {
            state.pageIndex = action.payload;
        },
        setOMRConfigPageSize(state, action) {
            state.size = action.payload;
        },
        setOMRConfigSearch(state, action) {
            state.search = action.payload;
        },
        resetOMRConfigState() {
            return initialState;
        }
    }
});

export const {
    setOMRConfigs,
    setOMRConfigTotalCount,
    addOMRConfig,
    updateOMRConfigInList,
    deleteOMRConfig,
    setOMRConfigPageIndex,
    setOMRConfigPageSize,
    setOMRConfigSearch,
    resetOMRConfigState
} = omrConfig.actions;

export default omrConfig.reducer;
